import { render, staticRenderFns } from "./package-list-loader.vue?vue&type=template&id=fa975c78"
import script from "./package-list-loader.vue?vue&type=script&lang=js"
export * from "./package-list-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports